import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-nav',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav/view.scss */
body {
  width: 100%;
}`],
})
export class ComponentNavComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public isMobileMenuOpen: boolean = false;
    public isUserMenuOpen: boolean = false;

    public async ngOnInit() {
        await this.service.init();
    }

    public activeClass(path: string): string {
        return location.pathname.startsWith(path) ? 'text-gray-900 font-semibold border-b-2 border-gray-700' : 'text-gray-600 hover:text-gray-900';
    }

    public toggleMobileMenu() {
        this.isMobileMenuOpen = !this.isMobileMenuOpen;
    }

    public toggleUserMenu() {
        this.isUserMenuOpen = !this.isUserMenuOpen;
    }

    public async logout() {
        await wiz.call("logout");
        location.href = "/login";
    }
}

export default ComponentNavComponent;